module.exports = __webpack_public_path__ + "static/media/StripePBG.346a0ca2.svg";